function Navigate(window, document, vueInstance, iframeRoute) {
    var ZJSC_NAVIGATE = {
        g: window,
        doc: document,
        app: vueInstance,
        route: iframeRoute,
        line: null,
        mousedownX: 0,
        moveFlag: false,
        Ajax: {
            getMenu: function (obj, route) {
                //console.info(route);
                if (route == "wybb" ||
                    route == "bblb" ||
                    route == "bcsmlb" ||
                    route == "xzsclb" ||
                    route == "sjtj" ||
                    route == "bbxtlssj") {
                    obj.Ajax.getBaobeiMenu(obj, route);
                    return;
                } else if (route == 'wybbjhb' ||
                    route == 'bblbjhb'
                ) {
                    obj.Ajax.getSimpleBaobeiMenu(obj, route);
                    return;
                } else if (route.indexOf("ZXPG") > -1) {
                    obj.Ajax.getZXPGMenu(obj, route);
                    return;
                }

                obj.g.jQuery.ajax({
                    //url: "../dist/static/json/menu.json",
                    url: "/api/user/commonUser/userMenu",
                    type: "get",
                    contentType: "application/json",
                    dataType: 'json',
                    headers: {
                        'Content-Type': "application/json",
                        'Authorization': sessionStorage.getItem("token")
                    },
                    success: function (res) {
                        if (res.code == 200 && res.result.code == 4000) {
                            //console.info(res.result.data);
                            var arr = res.result.data,
                                tree = null,
                                result = [],
                                firseRoute = [],
                                oDin = obj.Data.icon.nav;

                            arr.forEach(function (item) {
                                if (item.name == "备案审查") {
                                    tree = item.children;
                                }
                            });

                            setTree(result, tree, 0);

                        }

                        // 根据接口返回的数据生成菜单需要的格式
                        function setTree(result, tree, grade) {
                            if (tree) {
                                tree.forEach(function (item) {
                                    var obj = {
                                        "icon": grade == 0 ? (oDin[item.name] ? oDin[item.name] : "") : "",
                                        "name": item.name,
                                        "route": findRoute(item.name),
                                        "grade": grade,
                                        "father": findFather(item.name),
                                        "children": []
                                    };
                                    if (item.children) {
                                        setTree(obj.children, item.children, grade + 1);
                                    }
                                    result.push(obj);
                                });
                            } else {
                                return;
                            }
                        }

                        function findRoute(name) {
                            var roleType = sessionStorage.getItem("roleType");
                            switch (true) {
                                case name == "备案管理":
                                    return "bagl";
                                case name == "备案列表":
                                    var value = "";
                                    if (roleType == 4) {
                                        value = "balbCbr";
                                    } else if (roleType == 5) {
                                        value = "balbCsfzr";
                                    } else if (roleType == 6) {
                                        value = "balbLd";
                                    }
                                    firseRoute.push(value); // 保存打开的默认页路由
                                    return value;
                                case name == "综合查询":
                                    return "balbZhcx";
                                case name == "审查管理":
                                    if (roleType == 2 || roleType == 3) {
                                        firseRoute.push("sclb"); // 保存打开的默认页路由
                                    }
                                    return 'scgl';
                                case name == '审查列表':
                                    return 'sclb';
                                case name == '会审查询':
                                    return 'hscx';
                                case name == '会审列表':
                                    return 'hslb';
                                case name == '数据统计':
                                    return 'sjtj';
                                case name == '备案统计':
                                    return 'batj';
                                case name == '审查统计':
                                    return 'sctj';
                                case name == '数据总览':
                                    return 'sjzl';
                                case name == '公告管理':
                                    return 'gggl';
                                case name == '公告列表':
                                    return 'gglb';
                                case name == '新建公告':
                                    return 'xjgg';
                                case name == '协助审查':
                                    return 'xzsc';
                                case name == '历史数据统计':
                                    return 'lssjtj';
                                case name == '历史备案统计':
                                    return 'lsbatj';
                                case name == '历史审查统计':
                                    return 'lssctj';
                                case name == '历史数据':
                                    return "scxtlssj";
                            }
                        }

                        function findFather(name) {
                            switch (true) {
                                case name == '备案管理':
                                    return '/';
                                case name == '备案列表':
                                    return 'bagl';
                                case name == '综合查询':
                                    return 'bagl';
                                case name == '审查管理':
                                    return '/';
                                case name == '审查列表':
                                    return 'scgl';
                                case name == '会审查询':
                                    return 'scgl';
                                case name == '会审列表':
                                    return 'scgl';
                                case name == '数据统计':
                                    return '/';
                                case name == '备案统计':
                                    return 'sjtj';
                                case name == '审查统计':
                                    return 'sjtj';
                                case name == '数据总览':
                                    return 'sjtj';
                                case name == '公告管理':
                                    return '/';
                                case name == '公告列表':
                                    return 'gggl';
                                case name == '新建公告':
                                    return 'gggl';
                                case name == '协助审查':
                                    return '/';
                                case name == '历史数据统计':
                                    return '/';
                                case name == '历史备案统计':
                                    return 'lssjtj';
                                case name == '历史审查统计':
                                    return 'lssjtj';
                                case name == '历史数据':
                                    return '/';
                            }
                        }

                        obj.Data.menu = result; //res.data;

                        // 刷新后命中当前高亮的菜单项, 如果有缓存数据的话
                        if (sessionStorage.getItem("innerRoute")) {
                            route = sessionStorage.getItem("innerRoute");
                        } else {
                            route = firseRoute[0]; // 默认打开最顶部菜单项对应的页面
                        }
                        obj.Dom.setMenu(obj, result, route);
                    }
                });
            },
            getBaobeiMenu: function (obj, route) {
                obj.g.jQuery.ajax({
                    url: "../static/json/menu.json",
                    type: "get",
                    contentType: "application/json",
                    dataType: "json",
                    success: function (res) {
                        //console.info(res);
                        obj.Data.menu = res.data;
                        obj.Dom.setMenu(obj, res.data, route);
                    }
                });
            },
            // 简化版报备
            getSimpleBaobeiMenu: function (obj, route) {
                obj.g.jQuery.ajax({
                    url: "../static/json/simpleMenu.json",
                    type: "get",
                    contentType: "application/json",
                    dataType: "json",
                    success: function (res) {
                        obj.Data.menu = res.data;
                        obj.Dom.setMenu(obj, res.data, route);
                    }
                });
            },
            getZXPGMenu: function (obj, route) {
                obj.g.jQuery.ajax({
                    //url: "../static/json/zxpgMenu.json",
                    url: '/api/user/commonUser/userMenu',
                    type: 'get',
                    contentType: 'application/json',
                    dataType: 'json',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: sessionStorage.getItem('token'),
                    },
                    success: function (res) {
                        //console.info(res); return;
                        if (res.code == 200 && res.result.code == 4000) {
                            //console.info(res.result.data);
                            var arr = res.result.data,
                                tree = null,
                                result = [],
                                firseRoute = [],
                                oDin = obj.Data.icon.nav;

                            arr.forEach(function (item) {
                                if (item.name == '专项评估') {
                                    tree = item.children;
                                }
                            });

                            setTree(result, tree, 0);
                        }

                        // 根据接口返回的数据生成菜单需要的格式
                        function setTree(result, tree, grade) {
                            if (tree) {
                                tree.forEach(function (item) {
                                    var obj = {
                                        icon: grade == 0 ? (oDin[item.name] ? oDin[item.name] : '') : '',
                                        name: item.name,
                                        route: findRoute(item.name),
                                        grade: grade,
                                        father: findFather(item.name),
                                        children: [],
                                    };
                                    if (item.children) {
                                        setTree(obj.children, item.children, grade + 1);
                                    }
                                    result.push(obj);
                                });
                            } else {
                                return;
                            }
                        }

                        function findRoute(name) {
                            var roleType = sessionStorage.getItem('roleType');
                            switch (true) {
                                case name == '分发管理':
                                    return 'ffgl';
                                case name == '备案列表':
                                    var value = '';
                                    if (roleType == 4) {
                                        value = 'balbZXPGCbr';
                                    } else if (roleType == 5) {
                                        value = 'balbZXPGCsfzr';
                                    } else if (roleType == 6) {
                                        value = 'balbZXPGLd';
                                    }
                                    firseRoute.push(value); // 保存打开的默认页路由
                                    return value;
                                case name == '归档列表':
                                    if (roleType == 4) {
                                        firseRoute.push('gdlbZXPG'); // 保存打开的默认页路由
                                    }
                                    return 'gdlbZXPG';
                                case name == '评估管理':
                                    if (roleType == 2 || roleType == 3) {
                                        firseRoute.push('pglbZXPG'); // 保存打开的默认页路由
                                    }
                                    return 'pggl';
                                case name == '评估列表':
                                    return 'pglbZXPG';
                                case name == '会审列表':
                                    return 'hslbZXPG';

                                case name == '报备管理':
                                    if (roleType == 1) {
                                        firseRoute.push('bcsmZXPG'); // 保存打开的默认页路由
                                    }
                                    return 'bbglZXPG';
                                case name == '补充说明列表':
                                    return 'bcsmZXPG';
                                case name == '协助审查':
                                    return 'xzscZXPGF';
                                case name == '协助审查列表':
                                    return 'xzscZXPG';
                            }
                        }

                        function findFather(name) {
                            switch (true) {
                                case name == '分发管理':
                                    return '/';
                                case name == '备案列表':
                                    return 'ffgl';
                                case name == '归档列表':
                                    return 'ffgl';
                                case name == '评估管理':
                                    return '/';
                                case name == '评估列表':
                                    return 'pggl';
                                case name == '会审列表':
                                    return 'pggl';

                                case name == '报备管理':
                                    return '/';
                                case name == '补充说明列表':
                                    return 'bbglZXPG';
                                case name == '协助审查':
                                    return '/';
                                case name == '协助审查列表':
                                    return 'xzscZXPGF';
                            }
                        }

                        obj.Data.menu = result; //res.data;

                        // 刷新后命中当前高亮的菜单项, 如果有缓存数据的话
                        if (sessionStorage.getItem('innerRoute')) {
                            route = sessionStorage.getItem('innerRoute');
                        } else {
                            route = firseRoute[0]; // 默认打开最顶部菜单项对应的页面
                        }

                        obj.Dom.setMenu(obj, result, route);
                    },
                });
            },
        },
        Data: {
            sysName: "备案审查",
            icon: {
                down: "el-icon-arrow-down",
                up: "el-icon-arrow-up",
                right: "el-icon-arrow-right",
                nav: {
                    "备案管理": "el-icon-folder",
                    "审查管理": "el-icon-folder-checked",
                    "数据统计": "el-icon-s-data",
                    "公告管理": "el-icon-info",
                    "历史数据统计": "el-icon-discover",
                    "历史数据": "el-icon-help"
                }
            },
            id: "nav",
            menu: null,
            crumb: null
        },
        Dom: {
            openLoading: function (obj) {
                var doc = obj.doc;
                doc.querySelector(".app-div").style.display = "none";
                doc.querySelector("#loading").style.display = "block";
            },
            closeLoading: function (obj) {
                var doc = obj.doc;
                doc.querySelector(".app-div").style.display = "block";
                doc.querySelector("#loading").style.display = "none";
            },
            setMenu: function (obj, data, route) {
                if (data.length == 0) {
                    obj.app.$message.error("菜单数据为空");
                    return;
                }
                var oD = obj.Dom,
                    str = "",
                    icon = "",
                    status = "0",
                    className = "",
                    cssStr = "",
                    iconStr = "",
                    displayRoutes = obj.Dom.findRoutes(route, data);

                create(data);
                function create(data) {
                    for (var i = 0, len = data.length; i < len; i++) {
                        icon = obj.Data.icon.down;
                        status = "0";
                        className = "";
                        if (data[i].grade <= 0) {
                            cssStr = "display:block;padding-left:" + ((data[i].grade + 1) * 20) + "px;";
                        } else {
                            cssStr = "display:none;padding-left:" + ((data[i].grade + 1) * 20 + data[i].grade * 8) + "px;";
                        }
                        if (data[i].icon.length > 0) {
                            iconStr = "<i class='" + data[i].icon + "'></i>";
                        } else {
                            iconStr = "<i style='margin-right:0;'></i>";
                        }

                        // 默认展开及高亮
                        for (var j = 0, len2 = displayRoutes.length; j < len2; j++) {
                            if (data[i].route == displayRoutes[j]) {
                                cssStr += ";display:block;";
                                icon = obj.Data.icon.up;
                                status = "1";
                            }
                            if (data[i].father == displayRoutes[j]) {
                                cssStr += ";display:block;";
                            }
                        }
                        if (data[i].route == displayRoutes[0]) {
                            className = "cur";
                        }

                        if (data[i].children.length == 0) {
                            str += "<li class='" + className + "' style='" + cssStr + "' route='" + data[i].route + "' father='" + data[i].father + "'>" +
                                iconStr +
                                "<span>" + data[i].name + "</span>" +
                                "</li>";
                        } else {
                            str += "<li class='" + className + "' style='" + cssStr + "' status='" + status + "' route='" + data[i].route + "' father='" + data[i].father + "'>" +
                                iconStr +
                                "<span>" + data[i].name + "</span>" +
                                "<i class='" + icon + "'></i>"
                            "</li>";
                            create(data[i].children);
                        }
                    }
                }
                obj.g.setTimeout(function () {
                    obj.doc.querySelector("#nav").innerHTML = str;
                    obj.Event.register.nav(obj);
                    oD.createCrumb(obj, oD.getCrumbData(obj, route, data));
                }, 300);
            },
            findRoutes: function (route, data) {
                var result = [];
                find(route, data);

                function find(route, arr) {
                    for (var i = 0, len = arr.length; i < len; i++) {
                        if (arr[i].route == route) {
                            result.push(route);
                            if (arr[i].father != "/") {
                                find(arr[i].father, data);
                            }
                        } else if (arr[i].children.length > 0) {
                            find(route, arr[i].children);
                        }
                    }
                }

                return result;
            },
            route2name: function (routeArr, data) {
                var result = [];

                for (var j = 0, len2 = routeArr.length; j < len2; j++) {
                    find(routeArr[j], data);
                }

                function find(route, arr) {
                    for (var i = 0, len = arr.length; i < len; i++) {
                        if (arr[i].route == route) {
                            result.push(arr[i].name);
                        } else if (arr[i].children.length > 0) {
                            find(route, arr[i].children);
                        }
                    }
                }

                return result;
            },
            getCrumbData: function (obj, route, data) {
                var oD = obj.Dom,
                    routesArr = oD.findRoutes(route, data),
                    namesArr = oD.route2name(routesArr, data);
                return [routesArr, namesArr]; //namesArr;
            },
            createCrumb: function (obj, arr) {
                if (sessionStorage.getItem("CRUMB_DATA")) {
                    arr = JSON.parse(sessionStorage.getItem("CRUMB_DATA"));
                }
                //console.info(arr);
                obj.Data.crumb = arr;
                var len = arr[1].length - 1,
                    str = "<span class='sys-name'>" + obj.Data.sysName + "</span>";
                for (var i = len; i >= 0; i--) {
                    if (i == 0) {
                        str += "<i class='" + obj.Data.icon.right + "' style='color:#398BF7;'></i><span  class='cur' style=';cursor:pointer;' route='" + arr[0][i] + "'>" + arr[1][i] + "</span>";
                    } else {
                        str += "<i class='" + obj.Data.icon.right + "'></i><span style='cursor:pointer;' route='" + arr[0][i] + "'>" + arr[1][i] + "</span>";
                    }
                }
                obj.doc.querySelector(".container .right .crumb").innerHTML = str;
            },
            jump: function (obj, route) {
                obj.Dom.openLoading(obj);
                obj.app.$router.replace(route);
                obj.Dom.setMenu(obj, obj.Data.menu, route);
                obj.Dom.clearAndSetCur(obj, route);
            },
            clearAndSetCur: function (obj, route) {
                var doc = obj.doc,
                    lis = doc.querySelector("#nav").querySelectorAll("li"),
                    len = lis.length;

                for (var i = 0; i < len; i++) {
                    lis[i].className = "";
                    if (lis[i].getAttribute("route") == route) {
                        lis[i].className = "cur";
                    }
                }
            }
        },
        Event: {
            methods: {
                nav: function (e) {
                    var obj = ZJSC_NAVIGATE,
                        oD = obj.Dom,
                        oDi = obj.Data.icon,
                        nav = obj.doc.querySelector("#" + obj.Data.id),
                        lis = nav.querySelectorAll("li"),
                        menuData = obj.Data.menu,
                        target = e.target,
                        tagName = target.tagName.toUpperCase(0),
                        ele = null,
                        route = "",
                        father = "",
                        hasChildFlag = false,
                        allDescendantRoute = [];

                    if (tagName == "I" || tagName == "SPAN") {
                        route = target.parentNode.getAttribute("route");
                        father = target.parentNode.getAttribute("father");
                        ele = target.parentNode;
                    } else if (tagName == "LI") {
                        route = target.getAttribute("route");
                        father = target.getAttribute("father");
                        ele = target;
                    } else {
                        return;
                    }

                    checkHasChild(menuData, route);

                    if (ele.getAttribute("status")) {

                    } else {
                        if (ele.className == "cur") {
                            sessionStorage.removeItem("PAGE_INNER_JUMP_ROUTE");
                            sessionStorage.removeItem("CRUMB_DATA");
                            sessionStorage.removeItem("TAB_ACTIVE_NAME");
                            localStorage.removeItem('zxpgGdxqTagActiveIndex');
                            sessionStorage.removeItem("currentProjectId")
                            obj.Util.updateCrumb(obj, route);
                            obj.Util.reload(obj, route);
                            return;
                            //document.querySelector("#iframeRouteId").contentWindow.location.reload();
                            //return;
                        } else {
                            clearCur();
                            ele.className = "cur";
                        }
                    }

                    if (hasChildFlag) {
                        toggle(ele);
                    } else {
                        sessionStorage.removeItem("PAGE_INNER_JUMP_ROUTE");
                        sessionStorage.removeItem("CRUMB_DATA");
                        sessionStorage.removeItem("TAB_ACTIVE_NAME");
                        localStorage.removeItem("examineListSearch");
                        localStorage.removeItem("ExamineBackSign");
                        localStorage.removeItem('zxpgGdxqTagActiveIndex');
                        oD.createCrumb(obj, oD.getCrumbData(obj, route, menuData));
                        oD.openLoading(obj);
                        obj.app.$router.replace("/" + route);
                        sessionStorage.setItem("innerRoute", route);
                        sessionStorage.removeItem("currentProjectId")
                    }

                    // 清除高亮
                    function clearCur() {
                        for (var i = 0, len = lis.length; i < len; i++) {
                            lis[i].className = "";
                        }
                    }
                    // 判断是否有子元素
                    function checkHasChild(data, route) {
                        for (var i = 0, len = data.length; i < len; i++) {
                            if (data[i].route == route) {
                                if (data[i].children.length > 0) {
                                    hasChildFlag = true;
                                }
                            }
                            if (data[i].children.length > 0) {
                                checkHasChild(data[i].children, route);
                            }
                        }
                    }
                    // 交替
                    function toggle(ele) {
                        var status = ele.getAttribute("status");
                        if (status == "0") {
                            ele.querySelector(".el-icon-arrow-down").className = oDi.up;
                            ele.setAttribute("status", "1")
                            for (var i = 0, len = lis.length; i < len; i++) {
                                if (lis[i].getAttribute("father") == route) {
                                    lis[i].style.display = "block";
                                }
                            }
                        } else if (status == "1") {
                            ele.querySelector(".el-icon-arrow-up").className = oDi.down;
                            ele.setAttribute("status", "0");

                            findChildrenByRoute(menuData, route);
                            for (var i = 0, len = lis.length; i < len; i++) {
                                for (var j = 0, len2 = allDescendantRoute.length; j < len2; j++) {
                                    if (lis[i].getAttribute("route") == allDescendantRoute[j].route) {
                                        lis[i].style.display = "none";
                                        if (allDescendantRoute[j].status) {
                                            lis[i].setAttribute("status", "0");
                                            // 变更右侧图标
                                            lis[i].querySelectorAll("i")[1].className = "el-icon-arrow-down";
                                        }
                                    }
                                }
                            }

                        }
                    }
                    // 查询route对应的子元素
                    function findChildrenByRoute(arr, route) {
                        for (var i = 0, len = arr.length; i < len; i++) {
                            if (arr[i].route == route) {
                                findFirstDescendantRoute(arr[i].children);
                                break;
                            }
                            if (arr[i].children.length > 0) {
                                findChildrenByRoute(arr[i].children, route);
                            }
                        }
                    }
                    // 查找所有子元素（含嵌套）
                    function findFirstDescendantRoute(arr) {
                        for (var i = 0, len = arr.length; i < len; i++) {
                            allDescendantRoute.push({
                                "route": arr[i].route,
                                "status": arr[i].children.length > 0
                            });
                            if (arr[i].children.length > 0) {
                                findFirstDescendantRoute(arr[i].children);
                            }
                        }
                    }
                },
                crumb: function (e) {
                    var obj = ZJSC_NAVIGATE,
                        target = e.target;
                    if (target.getAttribute('route')) {
                        if (target.getAttribute('route') == 'bagl' ||
                            target.getAttribute('route') == 'scgl' ||
                            target.getAttribute('route') == 'sjtj' ||
                            target.getAttribute('route') == 'gggl' ||
                            target.getAttribute('route') == 'bbgl' ||
                            target.getAttribute('route') == 'xzsc' ||
                            target.getAttribute('route') == 'ffgl' ||
                            target.getAttribute('route') == 'bbglZXPG' ||
                            target.getAttribute('route') == 'xzscZXPGF' ||
                            target.getAttribute('route') == 'lssjtj' ||
                            target.getAttribute('route') == 'pggl') {
                            return;
                        } else {
                            if (target.className.toString().indexOf("cur") > -1) {
                                return;
                            } else {
                                var route = target.getAttribute("route");
                                //console.info(sessionStorage.getItem("innerRoute")); return;
                                //console.info(route);
                                obj.Util.updateCrumb(obj, route);
                                sessionStorage.setItem("PAGE_INNER_JUMP_ROUTE", route);

                                if (route == "sclb" || route == "zjtxyj" || route == "znfzsc" || route == "gglb") {
                                    document.querySelector("#iframeRouteId").src = "../../static/html/shencha/" + route + ".html";
                                } else {
                                    //console.info(route);
                                    if (route == "balbZhcx") {
                                        document.querySelector("#iframeRouteId").src = "../../static/html/beian/zhcxRecordList/list.html";
                                    } else if (route == "balb") { // 承办人
                                        document.querySelector("#iframeRouteId").src = "../../static/html/beian/cbrRecordList/list.html";
                                    } else if (route == "balbCsfzr") {
                                        document.querySelector("#iframeRouteId").src = "../../static/html/beian/csfzrRecordList/list.html";
                                    } else if (route == "balbLd") {
                                        document.querySelector("#iframeRouteId").src = "../../static/html/beian/ldRecordList/list.html";
                                    }
                                }

                                if (route == 'bblb') {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/report/reportList/list.html';
                                } else if (route == 'bblbjhb') {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/reportSimple/reportList/list.html';
                                } else if (route == 'bcsmlb') {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/report/suppleList/list.html';
                                } else if (route == 'xzsclb') {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/report/assistant/list.html';
                                }

                                /* edit-flag-20211229-lzq */
                                if (route == "gdlbZXPG") {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/zxpg/ffgl/gdlb/list.html';
                                } else if (route == "balbZXPGCbr") {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/zxpg/ffgl/balb/cbrRecordList/list.html';
                                } else if (route == 'balbZXPGCsfzr') {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/zxpg/ffgl/balb/csfzrRecordList/list.html';
                                } else if (route == 'balbZXPGLd') {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/zxpg/ffgl/balb/ldRecordList/list.html';
                                } else if (route == 'bcsmZXPG') { /* edit-flag-20211229-lzq */
                                    document.querySelector('#iframeRouteId').src = '../../static/html/zxpg/bbyzxpg/suppleList/list.html';
                                } else if (route == 'xzscZXPG') {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/zxpg/bbyzxpg/assistant/list.html';
                                }

                                if (route == 'pglbZXPG') {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/zxpg/pggl/pglb/list.html';
                                }

                                if (route == 'scxtlssj') {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/lssj/ba/list.html';
                                }
                                if (route == 'bbxtlssj') {
                                    document.querySelector('#iframeRouteId').src = '../../static/html/lssj/bb/list.html';
                                }
                            }
                        }
                    }
                },
                mousedown: function (e) {
                    var obj = ZJSC_NAVIGATE,
                        target = e.target;
                    if (target.id === "line") {
                        obj.line = target;
                        obj.mousedownX = e.clientX;
                        obj.doc.addEventListener("mousemove", obj.Event.methods.mousemove, false);
                        obj.Dom.openLoading(obj);
                    }
                },
                mousemove: function (e) {
                    var obj = ZJSC_NAVIGATE,
                        doc = obj.doc,
                        nav = doc.querySelector("#nav"),
                        omX = obj.mousedownX,
                        ogpI = obj.g.parseInt,
                        width = 0,
                        left = 0;

                    if (e.clientX - omX > 0) {
                        width = ogpI(nav.style.width, 10);
                        nav.style.cssText += "width: " + (width + 1) + "px;";
                        obj.line.style.cssText += "left: " + (width - 5 + 1) + "px;";
                        obj.line.className = "line line-cur";
                    } else if (e.clientX - omX < 0) {
                        width = ogpI(nav.style.width, 10);
                        left = width - 1 - 5;
                        if (width <= 230) {
                            width = 231;
                            left = 225;
                        }
                        nav.style.cssText += "width: " + (width - 1) + "px;";
                        obj.line.style.cssText += "left: " + left + "px;";
                        obj.line.className = "line line-cur";
                    }
                    doc.querySelector(".right").style.cssText += "; left: " + (ogpI(nav.style.width, 10)) + "px;";
                    obj.moveFlag = true;
                },
                mouseup: function (e) {
                    var obj = ZJSC_NAVIGATE;
                    obj.doc.removeEventListener("mousemove", obj.Event.methods.mousemove, false);
                    if (obj.moveFlag) {
                        obj.line.className = "line";
                        obj.moveFlag = false;
                    }
                    obj.mousedownX = 0;
                    obj.line = null;
                    obj.Dom.closeLoading(obj);
                }
            },
            register: {
                nav: function (obj) {
                    obj.doc.querySelector("#nav").addEventListener("click", obj.Event.methods.nav, false);
                    return this;
                },
                crumb: function (obj) {
                    obj.doc.querySelector(".container .right .crumb").addEventListener("click", obj.Event.methods.crumb, false);
                    return this;
                },
                mousedown: function (obj) {
                    var line = obj.doc.querySelector("#line");
                    line.addEventListener("mousedown", obj.Event.methods.mousedown, false);
                    return this;
                },
                mouseup: function (obj) {
                    obj.doc.addEventListener("mouseup", obj.Event.methods.mouseup, false);
                    return this;
                },
            },
            remove: {

            }
        },
        Util: {
            hasLogin: function (obj) {
                if (obj.g.sessionStorage.getItem("token")) {
                    obj.token = obj.g.sessionStorage.getItem("token");
                    return true;
                } else {
                    obj.g.location.href = "/login";
                }
            },
            getRandomNum: function (obj, end) {
                var gM = obj.g.Math;
                return gM.floor(gM.random() * end);
            },
            getRandomStr: function (obj, length) {
                var str = "abcdefghijklmnopqrstuvwxyz0123456789",
                    arr = str.split(""),
                    oUgRN = obj.Util.getRandomNum,
                    value = [],
                    order = 0;

                for (var i = 0; i < length; i++) {
                    value.push(arr[oUgRN(obj, 36)]);
                }
                for (var i = 0; i < length; i++) {
                    order = oUgRN(obj, length);
                    value[order] = value[order].toUpperCase();
                }
                return value.join("");
            },
            getRoute: function (obj) {
                return obj.g.location.href.split("#/")[1];
            },
            updateCrumb: function (obj, route) {
                sessionStorage.removeItem("CRUMB_DATA")
                var arr = null;
                switch (true) {
                    case route == "wybb":
                        arr = [["wybb"], ["我要报备"]];
                        break;
                    case route == "bblb":
                        arr = [["bblb", "bbwj"], ["报备列表", "报备管理"]];
                        break;
                    case route == "reportListDetail":
                        arr = [["reportListDetail", "bblb", "bbwj"], ["查看", "报备列表", "报备管理"]];
                        break;
                    case route == "reportListEdit":
                        arr = [["reportListEdit", "bblb", "bbwj"], ["修改/重报", "报备列表", "报备管理"]];
                        break;
                    case route == "reportListEditCorrect":
                        arr = [["reportListEditCorrect", "bblb", "bbwj"], ["纠正", "报备列表", "报备管理"]];
                        break;
                    case route == "bcsmlb":
                        arr = [["bcsmlb", "bbwj"], ["补充说明列表", "报备管理"]];
                        break;
                    case route == "reportDetailBCSM":
                        arr = [["reportDetailBCSM", "bcsmlb", "bbwj"], ["查看", "补充说明列表", "报备管理"]];
                        break;
                    case route == "detailBCSM":
                        arr = [["detailBCSM", "bcsmlb", "bbwj"], ["查看", "补充说明列表", "报备管理"]];
                        break;
                    case route == "addBCSM":
                        arr = [["addBCSM", "bcsmlb", "bbwj"], ["补充", "补充说明列表", "报备管理"]];
                        break;
                    case route == "xzsclb":
                        arr = [["xzsclb", "bbwj"], ["协助审查列表", "报备管理"]];
                        break;
                    case route == "reportDetailAssistant":
                        arr = [["reportDetailAssistant", "xzsclb", "bbwj"], ["查看", "协助审查列表", "报备管理"]];
                        break;
                    case route == "detailAssistant":
                        arr = [["detailAssistant", "xzsclb", "bbwj"], ["查看", "协助审查列表", "报备管理"]];
                        break;
                    case route == "assistantXZSCLB":
                        arr = [["assistantXZSCLB", "xzsclb", "bbwj"], ["协审", "协助审查列表", "报备管理"]];
                        break;
                    //-------------------------------------------------------------------------------------------------------------------
                    case route == "sclb":
                        arr = [["sclb", "scgl"], ["审查列表", "审查管理"]];
                        break;
                    case route == "examine":
                        arr = [["examine", "sclb", "scgl"], ["审批", "审查列表", "审查管理"]];
                        break;
                    case route == "zjtxyj":
                        arr = [["zjtxyj", "sclb", "scgl"], ["直接填写意见", "审查列表", "审查管理"]];
                        break;
                    case route == "znfzsc":
                        arr = [["znfzsc", "sclb", "scgl"], ["智能辅助审查", "审查列表", "审查管理"]];
                        break;
                    case route == "bascyjs":
                        arr = [["bascyjs", "znfzsc", "sclb", "scgl"], ["备案审查意见", "智能辅助审查", "审查列表", "审查管理"]];
                        break;
                    case route == "examinescdzb":
                        arr = [["examinescdzb", "znfzsc", "sclb", "scgl"], ["审批", "智能辅助审查", "审查列表", "审查管理"]];
                        break;
                    case route == "sclb":
                        arr = [["sclb", "scgl"], ["审查列表", "审查管理"]];
                        break;

                    case route == "scxtlssj":
                        arr = [["scxtlssj"], ["历史数据"]];
                        break;
                    case route == "descriptionDetailsLSSJ_BA":
                        arr = [["descriptionDetailsLSSJ_BA", "scxtlssj"], ["查看", "历史数据"]];
                        break;
                    case route == "bbxtlssj":
                        arr = [["bbxtlssj"], ["历史数据"]];
                        break;
                    case route == "descriptionDetailsLSSJ_BB":
                        arr = [["descriptionDetailsLSSJ_BB", "bbxtlssj"], ["查看", "历史数据"]];
                        break;

                    case route == "gglb":
                        arr = [["gglb", "gggl"], ["公告列表", "公告管理"]];
                        break;
                    case route == "xjgg":
                        arr = [["xjgg", "gggl"], ["新建公告", "公告管理"]];
                        break;
                    case route == "bjgg":
                        arr = [["bjgg", "gglb", "gggl"], ["查看/编辑", "公告列表", "公告管理"]];
                        break;
                    //-------------------------------------------------------------------------------------------------------------------
                    // 简化版报备-开始
                    // case route == "wybbjhb":
                    //     arr = [["wybbjhb"], ["我要报备"]];
                    //     break;
                    case route == "bblbjhb":
                        arr = [["bblbjhb"], ["报备列表"]];
                        break;
                    case route == "reportListJhbDetail":
                        arr = [["reportListJhbDetail", "bblbjhb"], ["查看", "报备列表"]];
                        break;
                    case route == "reportListJhbEdit":
                        arr = [["reportListJhbEdit", "bblbjhb"], ["修改/重报", "报备列表"]];
                        break;
                    case route == "reportListJhbEditCorrect":
                        arr = [["reportListJhbEditCorrect", "bblbjhb"], ["纠正", "报备列表"]];
                        break;
                    // 简化版报备-结束
                    case route == "balb":
                        arr = [["balb", "bagl"], ["备案列表", "备案管理"]];
                        break;
                    case route == "balbCbr":
                        arr = [["balbCbr", "bagl"], ["备案列表", "备案管理"]];
                        break;
                    case route == "balbCsfzr":
                        arr = [["balbCsfzr", "bagl"], ["备案列表", "备案管理"]];
                        break;
                    case route == "balbLd":
                        arr = [["balbLd", "bagl"], ["备案列表", "备案管理"]];
                        break;
                    case route == "examineDetail":
                        arr = [["examineDetail", "balb", "bagl"], ["审查详情", "备案列表", "备案管理"]];
                        break;
                    case route == "examineCsfzr":
                        arr = [["examineCsfzr", "balbCsfzr", "bagl"], ["审批", "备案列表", "备案管理"]];
                        break;
                    case route == "examineCsfzrDetail":
                        arr = [["examineCsfzrDetail", "balbCsfzr", "bagl"], ["审批详情", "备案列表", "备案管理"]];
                        break;
                    case route == "examineLd":
                        arr = [["examineLd", "balbLd", "bagl"], ["审批", "备案列表", "备案管理"]];
                        break;
                    case route == "examineLdDetail":
                        arr = [["examineLdDetail", "balbLd", "bagl"], ["审批详情", "备案列表", "备案管理"]];
                        break;
                    case route == "checkDraft":
                        arr = [["checkDraft", "balb", "bagl"], ["核稿", "备案列表", "备案管理"]];
                        break;
                    case route == "fileDetail":
                        arr = [["fileDetail", "balb", "bagl"], ["归档查看", "备案列表", "备案管理"]];
                        break;
                    case route == "descriptionDetailsPt2":
                        arr = [["descriptionDetailsPt2", "balb", "bagl"], ["查看", "备案列表", "备案管理"]];
                        break;
                    case route == "descriptionDetailsPtCsfzr":
                        arr = [["descriptionDetailsPtCsfzr", "balbCsfzr", "bagl"], ["查看", "备案列表", "备案管理"]];
                        break;
                    case route == "descriptionDetailsPtLd":
                        arr = [["descriptionDetailsPtLd", "balbLd", "bagl"], ["查看", "备案列表", "备案管理"]];
                        break;

                    case route == "balbZhcx":
                        arr = [["balbZhcx", "bagl"], ["综合查询", "备案管理"]];
                        break;
                    case route == 'descriptionDetailsPt':
                        arr = [['descriptionDetailsPt', 'balbZhcx', 'bagl'], ['查看', '综合查询', '备案管理']];
                        break;
                    //-------------------------------------------
                    case route == 'pglb':
                        arr = [['pglb', 'pggl'], ['评估列表', '评估管理']];
                        break;
                    case route == 'descriptionDetailsPt2ZXPG':
                        arr = [['descriptionDetailsPt2ZXPG', 'gdlbZXPG', 'ffgl'], ['查看', '归档列表', '分发管理']];
                        break;
                    case route == 'gdlbZXPG':
                        arr = [['gdlbZXPG', 'ffgl'], ['归档列表', '分发管理']];
                        break;
                    case route == 'fileDetailZXPG':
                        arr = [['fileDetailZXPG', 'gdlbZXPG', 'ffgl'], ['专项评估', '归档列表', '分发管理']];
                        break;
                    case route == 'listZXPG':
                        arr = [['listZXPG', 'ffgl'], ['归档列表', '分发管理']];
                        break;
                    case route == 'descriptionDetailsPt2ZXPG2':
                        arr = [['descriptionDetailsPt2ZXPG2', 'balbZXPGCbr', 'ffgl'], ['查看', '备案列表', '分发管理']];
                        break;
                    case route == 'examineCbrZXPG':
                        arr = [['examineCbrZXPG', 'balbZXPGCbr', 'ffgl'], ['审批', '备案列表', '分发管理']];
                        break;
                    case route == 'checkDraftCbrZXPG':
                        arr = [['checkDraftCbrZXPG', 'balbZXPGCbr', 'ffgl'], ['核稿', '备案列表', '分发管理']];
                        break;
                    case route == 'fileDetailCbrZXPG':
                        arr = [['fileDetailCbrZXPG', 'balbZXPGCbr', 'ffgl'], ['查看', '备案列表', '分发管理']];
                        break;
                    case route == 'balbZXPGCbr':
                        arr = [['balbZXPGCbr', 'ffgl'], ['备案列表', '分发管理']];
                        break;
                    case route == 'descriptionDetailsPtCsfzrZXPG':
                        arr = [['descriptionDetailsPtCsfzrZXPG', 'balbZXPGCsfzr', 'ffgl'], ['查看', '备案列表', '分发管理']];
                        break;
                    case route == 'examineCsfzrZXPG':
                        arr = [['examineCsfzrZXPG', 'balbZXPGCsfzr', 'ffgl'], ['审批', '备案列表', '分发管理']];
                        break;
                    case route == 'balbZXPGCsfzr':
                        arr = [['balbZXPGCsfzr', 'ffgl'], ['备案列表', '分发管理']];
                        break;
                    case route == 'descriptionDetailsPtLdZXPG':
                        arr = [['descriptionDetailsPtLdZXPG', 'balbZXPGLd', 'ffgl'], ['查看', '备案列表', '分发管理']];
                        break;
                    case route == 'examineLdZXPG':
                        arr = [['examineLdZXPG', 'balbZXPGLd', 'ffgl'], ['审批', '备案列表', '分发管理']];
                        break;
                    case route == 'balbZXPGLd':
                        arr = [['balbZXPGLd', 'ffgl'], ['备案列表', '分发管理']];
                        break;
                    case route == 'reportDetailBCSMZXPG':
                        arr = [['reportDetailBCSMZXPG', 'bcsmZXPG', 'ffgl'], ['查看', '补充说明列表', '报备管理']];
                        break;
                    case route == 'addBCSMZXPG':
                        arr = [['addBCSMZXPG', 'bcsmZXPG', 'ffgl'], ['补充', '补充说明列表', '报备管理']];
                        break;
                    case route == 'detailBCSMZXPG':
                        arr = [['detailBCSMZXPG', 'bcsmZXPG', 'ffgl'], ['查看', '补充说明列表', '报备管理']];
                        break;
                    case route == 'bcsmZXPG':
                        arr = [['bcsmZXPG', 'ffgl'], ['补充说明列表', '报备管理']];
                        break;
                    case route == 'reportDetailAssistantZXPG':
                        arr = [['reportDetailAssistantZXPG', 'xzscZXPG', 'ffgl'], ['查看', '协助审查列表', '协助审查']];
                        break;
                    case route == 'assistantXZSCLBZXPG':
                        arr = [['assistantXZSCLBZXPG', 'xzscZXPG', 'ffgl'], ['协审', '协助审查列表', '协助审查']];
                        break;
                    case route == 'detailAssistantZXPG':
                        arr = [['detailAssistantZXPG', 'xzscZXPG', 'ffgl'], ['查看', '协助审查列表', '协助审查']];
                        break;
                    case route == 'xzscZXPG':
                        arr = [['xzscZXPG', 'ffgl'], ['协助审查列表', '协助审查']];
                        break;

                    case route == 'pgznfzscZXPG':
                        arr = [['pgznfzscZXPG', 'pglbZXPG', 'pggl'], ['智能辅助审查', '评估列表', '评估管理']];
                        break;
                    case route == 'pgzjtxyjZXPG':
                        arr = [['pgzjtxyjZXPG', 'pglbZXPG', 'pggl'], ['直接填写意见', '评估列表', '评估管理']];
                        break;
                    case route == 'pglbZXPG':
                        arr = [['pglbZXPG', 'pggl'], ['评估列表', '评估管理']];
                        break;
                }
                obj.Dom.createCrumb(obj, arr);
                sessionStorage.setItem("CRUMB_DATA", JSON.stringify(arr));
            },
            reload: function (obj, route) {
                document.querySelector("#iframeRouteId").contentWindow.location.replace(obj.route[route]);
            },
        },
        Init: {
            start: function (obj) {
                if (obj.Util.hasLogin(obj)) {
                    var route = obj.Util.getRoute(obj);

                    if (route.indexOf('ZXPG') > -1) {
                        obj.Data.sysName = '评估系统';
                    } else if (route == "wybb" ||
                        route == "bblb" ||
                        route == "bcsmlb" ||
                        route == "xzsclb" ||
                        route == "sjtj" ||
                        route == "bbxtlssj") {
                        obj.Data.sysName = '报备系统';
                    } else if (route.indexOf('wybbjhb') > -1 || route.indexOf('bblbjhb') > -1) {
                        obj.Data.sysName = '报备系统';
                    } else {
                        obj.Data.sysName = '审查系统';
                    }

                    obj.Ajax.getMenu(obj, route);
                    obj.Event.register.crumb(obj).mousedown(obj).mouseup(obj);
                }
            }
        }
    };
    ZJSC_NAVIGATE.Init.start(ZJSC_NAVIGATE);
    window.ZJSC_NAVIGATE = ZJSC_NAVIGATE;
}
export default Navigate;